import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { track } from "../lib/analytics";
import ProductCard from "../components/ProductCard";

export default function Search() {
    const [params] = useSearchParams();
    const q = params.get("q") || "";
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        document.title = `Search "${q}" | Loomara`;
        setLoading(true);
        api.get("/products", { params: { q, limit: 60 } }).then(({ data }) => {
            setResults(data);
            track("search", { search_term: q, results_count: data.length });
        }).finally(() => setLoading(false));
    }, [q]);

    return (
        <div className="container-boutique py-16" data-testid="search-page">
            <p className="eyebrow">Search</p>
            <h1 className="font-serif text-4xl sm:text-5xl text-ink-900 mt-3">
                Results for <span className="italic text-sage-600">"{q}"</span>
            </h1>
            <p className="text-ink-500 mt-2">{loading ? "Searching…" : `${results.length} ${results.length === 1 ? "piece" : "pieces"} found`}</p>

            {!loading && results.length === 0 && (
                <div className="text-center py-16 text-ink-500">
                    <p>We couldn't find anything just yet. Try another search term.</p>
                </div>
            )}

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-10" data-testid="search-results-grid">
                {results.map((p, i) => (<ProductCard key={p.id} product={p} index={i} listName="search" />))}
            </div>
        </div>
    );
}
